import classNames from 'clsx'
import { bool, func, node, number, oneOf, string } from 'prop-types'

import Button from 'views/components/atoms/Button'
import DeprecatedIcon from 'views/components/atoms/Icon/DeprecatedIcon'
import { POSITION_TYPES } from 'views/components/organisms/Collapsible/consts'

import './ButtonCollapsible.scss'

const ButtonCollapsible = props => {
  const {
    children,
    position,
    positionSmallTiny,
    light,
    noBorder,
    icon,
    reverse,
    headerColor,
    maxLines,
    disableClientSideHook,
    ...rest
  } = props

  const classname = classNames('m-Button--collapsible', {
    [`m-Button--collapsible--${position}`]: position,
    [`m-Button--collapsible--${positionSmallTiny}@small-tiny`]:
      positionSmallTiny,
    'm-Button--collapsible--light': light,
    'm-Button--collapsible--no-border': noBorder,
    [`m-Button--collapsible--${headerColor}`]: headerColor,
  })

  const labelClassName = classNames('a-Button__label', {
    'a-truncate-with-ellipsis': maxLines <= 1,
    'm-Button--collapsible-max-lines': maxLines > 1,
  })

  const labelProps = {
    className: labelClassName,
  }

  if (maxLines > 1) {
    labelProps.style = {
      'WebkitLineClamp': maxLines,
    }
  }

  const iconComponent = (
    <DeprecatedIcon
      icon={icon}
      className="u-color--blue m-Button--collapsible__icon"
    />
  )

  return (
    <Button
      {...rest}
      className={classname}
      data-clientside-hook={
        !disableClientSideHook ? 'expander__button' : undefined
      }
    >
      {reverse && iconComponent}
      <span {...labelProps}>{children}</span>
      {!reverse && iconComponent}
    </Button>
  )
}

ButtonCollapsible.propTypes = {
  children: node.isRequired,
  onClick: func,
  expanded: bool,
  ariaControls: string,
  position: oneOf(POSITION_TYPES),
  positionSmallTiny: oneOf(POSITION_TYPES),
  light: bool,
  noBorder: bool,
  icon: string,
  reverse: bool,
  headerColor: string,
  maxLines: number,
  disableClientSideHook: bool,
}

ButtonCollapsible.defaultProps = {
  onClick: null,
  expanded: null,
  ariaControls: null,
  position: null,
  positionSmallTiny: null,
  light: false,
  noBorder: false,
  icon: 'caretDown',
  reverse: false,
  headerColor: null,
  maxLines: 1,
  disableClientSideHook: false,
}

export default ButtonCollapsible
